// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { useState } from 'react';
import { Modal } from './Modal';

export interface LogoutModalProps {
  open: boolean;
  onClose: () => void;
  /** URL to redirect to after logout. Defaults to '/login'. */
  redirectUrl?: string;
  /** API endpoint for logout. Defaults to '/api/auth/logout'. */
  logoutEndpoint?: string;
}

export function LogoutModal({
  open,
  onClose,
  redirectUrl = '/login',
  logoutEndpoint = '/api/auth/logout',
}: LogoutModalProps) {
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    try {
      await fetch(logoutEndpoint, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      // Always redirect even if the API call fails
      console.error('Logout error:', err);
    } finally {
      window.location.href = redirectUrl;
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      className="fin-modal--compact"
      closeOnOverlayClick={!loading}
      closeOnEscape={!loading}
    >
      <Modal.Header title="Log out" onClose={loading ? undefined : onClose} />
      <Modal.Content>
        <p style={{ margin: 0, fontSize: 16, color: '#333333', lineHeight: 1.4 }}>
          Are you sure you want to log out?
        </p>
      </Modal.Content>
      <Modal.Actions
        secondaryAction={{
          label: 'Cancel',
          onClick: onClose,
          disabled: loading,
        }}
        primaryAction={{
          label: 'Log Out',
          onClick: handleLogout,
          loading,
          disabled: loading,
        }}
      />
    </Modal>
  );
}
